import { children, text } from "@nozbe/watermelondb/decorators";
import { BaseModel } from "./Base";
import { Associations } from "@nozbe/watermelondb/Model";
import LayoutNode from "./LayoutNode";
import { Query } from "@nozbe/watermelondb";

export default class Layout extends BaseModel {
  static table = "layouts";

  static associations: Associations = {
    layout_nodes: { type: "has_many", foreignKey: "layout_id" },
  };

  @children("layout_nodes")
  nodes: Query<LayoutNode>;

  @text("terminal_id") terminalId: string;
}
